/* eslint-disable quotes */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Heading from "../../components/Heading";
import "./styles.scss";

import LockedShipments from "./LockedShipments";

function NotBooked() {
  const [searchParams] = useSearchParams();
  const ruleId = searchParams.get("rule_id") || "LOCK_NOT_BOOKED";

  const getTitle = (rule) => {
    if (!rule) return "Locked Shipments";

    const commonAcronyms = ["CP", "DRS", "POD", "RTO", "COD", "PREPAID"];
    const knownTitles = {
      LOCK_NOT_BOOKED: "Not Booked Shipments",
      LOCK_POD_UPLOAD: "POD Upload Pending",
      LOCK_DRS_STATUS_UPDATE: "DRS Status Update Pending",
    };

    if (knownTitles[rule]) {
      return knownTitles[rule];
    }

    // Dynamic formatting for other rules
    return rule
      .replace(/^LOCK_/, "")
      .split("_")
      .map((word) => {
        if (commonAcronyms.includes(word)) return word;
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  };

  return (
    <div className="not-booked-container">
      <div style={{ margin: "20px 15px 10px 15px" }}>
        <Heading title={getTitle(ruleId)} />
      </div>
      <div style={{ padding: "0 15px" }}>
        <LockedShipments ruleId={ruleId} />
      </div>
    </div>
  );
}

export default NotBooked;
